"use client";

import { useRef } from "react";
import { useInView } from "motion/react";
import dynamic from "next/dynamic";

// Recharts is ~242KB — dynamically import so it's only fetched when the
// component scrolls into view rather than being included in the initial bundle.
const LineChartInner = dynamic(
  () =>
    import("./line-chart-inner").then((m) => ({ default: m.LineChartInner })),
  { ssr: false },
);

export interface LineChartDataPoint {
  name: string;
  date: string;
  pv: number;
}

export interface LineChartDataSet {
  id: string;
  data: LineChartDataPoint[];
  tickValues?: number[];
  description?: string;
  unit?: string;
}

export interface LineChartProps {
  dataset: LineChartDataSet;
  graphHeight?: string | number;
  isTile?: boolean;
  isWhite?: boolean;
}

export function LineChart(props: LineChartProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, margin: "200px 0px" });

  return (
    <div ref={ref} className="h-full w-full">
      {isInView ? <LineChartInner {...props} /> : null}
    </div>
  );
}
